export const styles = {
  container:
    "flex justify-between items-center px-5 py-2 text-sm border-t bg-white relative overflow-visible rounded-bl-xl rounded-br-xl",
  left: "",
  right: "flex items-center gap-3",
  sizeWrapper: "relative",
  sizeButton:
    "flex items-center justify-between border px-3 py-1 rounded-lg min-w-[60px] bg-white shadow-sm",
  sizeList: "absolute mt-1 left-0 w-28 bg-white shadow-lg rounded-lg py-2 border z-[99999]",
  sizeItem: "px-4 py-2 cursor-pointer flex items-center gap-2 hover:bg-gray-100",
  sizeItemActive: "bg-blue-50 text-blue-700",
  navWrapper: "flex items-center gap-1",
  navBtn: "px-2 py-1 rounded-md border text-xs bg-white hover:bg-gray-100 transition shadow-sm",
  navDisabled: "opacity-40 cursor-not-allowed",
};
